import * as React from 'react';
import { useEffect } from 'react';
import api from "../../utils/api_v2";
import LodingData from "../../utils/LodingData";
import * as util from "../../utils/util";
import Top from "../Top";
import Bottom from "../Bottom";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import { useNavigate } from 'react-router-dom';
import icon_inspection1 from "../../assets/images/infor_01.png";
import icon_inspection2 from "../../assets/images/infor_02.png";
import icon_inspection3 from "../../assets/images/infor_03.png";
import icon_inspection4 from "../../assets/images/infor_04.png";
import icon_inspection5 from "../../assets/images/infor_05.png";
import icon_inspection6 from "../../assets/images/infor_06.png";
import icon_inspection7 from "../../assets/images/infor_07.png";
import icon_inspection8 from "../../assets/images/infor_08.png";
import icon_inspection9 from "../../assets/images/infor_09.png";
import icon_inspection10 from "../../assets/images/infor_10.png";
import icon_inspection11 from "../../assets/images/infor_11.png";
import icon_inspection12 from "../../assets/images/infor_12.png";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import HealthResultItem from "./HealthResultItem";
import HealthResultTotal from "./HealthResultTotal";
import HealthResultCompare from "./HealthResultCompare";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';

import tabbg from "../../assets/images/tab_02.png"


const HealthResult = () => {

  const navigate = useNavigate();
  const [resultData, setResultData] = React.useState([]);
  const [ownerFamID, setOwnerFamID] = React.useState('');
  const [memberName, setMemberName] = React.useState('비회원');
  const [isFrist, setIsFrist] = React.useState(true);

  useEffect(() => {

    setOwnerFamID(localStorage.getItem('ownerFamID') || '');
    const userCusID = localStorage.getItem('userCusID') || '';
    api.post('customer/api/v1/CU_005_001', { cusId: userCusID }).then(res => {
      if (res.data.length > 0) {
        for (let tp of res.data) {
          if (tp.famId === localStorage.getItem('ownerFamID') || '') {  // 본인 검진 결과만 조회
            LodingData(() => api.post('customer/api/v1/CU_005_002', { famId: tp.famId }).then(res => {
              let resultTemp = res.data.map((v: any) => true ? { ...v, famName: tp.famName, famId: tp.famId } : v);
              setResultData((prev) => prev.concat(resultTemp).sort(compare).reverse());
            }).catch(function (error) {
              console.log(error)
            }).finally(() => {
              setIsFrist(false);
            }));
          }
        }
      } else {
        LodingData(() => { }).finally(() => setIsFrist(false));
      }
    }).catch(function (error) {
      console.log(error)
    });

    api.get('permission/getProfile').then((res: any) => {
      setMemberName(res.data.name);
    }).catch(function (error: any) {
      console.log(error)
    });

  }, []);

  function compare(a: any, b: any) {
    if (a.year < b.year) {
      return -1;
    }
    if (a.year > b.year) {
      return 1;
    }
    return 0;
  }


  const img = {
    display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
  }

  return (
    <Container className='container' sx={{ mb: 8 }}>
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#b2f7ab', fontWeight: 900, }}>
              검진결과
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ee725', fontWeight: 500, }} gutterBottom>
              종합검진
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <ButtonGroup
        disableElevation
        variant="contained"
        aria-label="Disabled button group"
        sx={{ justifyContent: 'center', width: '100%' }}
      >
        <Box sx={{ width: '80%', background: '#ccc !important', '& a': { width: '50%!important', }, '& a:hover': { bgcolor: '#074300 !important' } }}>
          <Button href="../MyPage/HealthResult" sx={{ bgcolor: '#0d6703 !important', border: '1px solid #0d6703 !important' }}>종합결과</Button>
          <Button href="../MyPage/HealthMResult" sx={{ bgcolor: '#ccc' }}>주요결과</Button>
        </Box>
      </ButtonGroup>


      {/* <Card sx={{ borderRadius: 3, mt: 4, p: 2, }}>
         <Stack direction={'row'} >
            <Typography sx={{ fontSize: 16, fontWeight: 700 }}>검진결과 내역</Typography>
            <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#555', ml: 'auto' }} />
          </Stack>
          <Divider sx={{ mt: 1, mb: 1.5 }} /> 

        <Stack direction={'column'} justifyContent={'space-evenly'} alignItems={'center'}>
          <Typography sx={{ fontSize: 16, fontWeight: 700 }}>{memberName}<Typography component={'span'} sx={{ fontSize: 14 }}> 님의 검진 결과 </Typography></Typography>
          <Typography sx={{ mt: 1, fontSize: 16, fontWeight: 700 }}>{resultData.filter((v: any) => v.famId === ownerFamID).length}<Typography component={'span'} sx={{ fontSize: 14 }}> 건</Typography></Typography>

          <Card sx={{ mt: 2, border: '1px solid #f18322', py: .5, px: 2, borderRadius: 5, }}>
            <HealthResultCompare
              componentName={'최근 3년 결과 비교'}
              anchor="bottom" />
          </Card>
        </Stack>
      </Card> */}

      {
        isFrist
          ? null
          :
          resultData.length <= 0
            ? (
              localStorage.getItem('hraSurvey') == 'true'
                ? <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 10, }}>
                  <ContentPasteOffIcon sx={{ fontSize: 50, color: '#bbb' }} />
                  <Typography sx={{ fontSize: 16, color: '#888' }} >뇌심혈관질환 발병위험도평가 완료 후 검진 결과를 열람하실 수 있습니다.</Typography>
                  <Box sx={BtnStyle}>
                    <Button variant="contained" sx={BottomBtnStyle} onClick={() => { navigate('/hra') }}>
                      평가하기
                    </Button>
                  </Box>
                </Stack>
                : <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 10, }}>
                  <ContentPasteOffIcon sx={{ fontSize: 50, color: '#bbb' }} />
                  <Typography sx={{ fontSize: 16, color: '#888' }} >검사 결과가 없습니다.</Typography>
                </Stack>
            )
            : (
              resultData && resultData.map((result: any, index: any) => (
                <Card sx={{ borderRadius: 3, mt: 4, width: '80%', ml: 'auto', mr: 'auto' }}>
                  {/* <BeenhereIcon sx={{ fontSize: 40, position: 'absolute', color: '#007e05de' }} /> 확정시  */}

                  <Stack direction="row" justifyContent={'center'} alignItems="center" spacing={2} sx={{ p: 2, pt: 4 }}>
                    <Typography sx={{ fontWeight: 700, }} >{result.year}</Typography>
                    <Typography sx={{ fontSize: 14, }}>{result.hospitalName}</Typography>
                  </Stack>

                  <Stack direction="row" justifyContent={'center'} spacing={2} sx={{ pb: 4 }}>
                    <Typography sx={{ fontSize: 18, fontWeight: 700, }}>
                      {result.famName}
                      <Typography component={'span'} sx={{ fontSize: 16, }}>({result.famId === ownerFamID ? '본인' : '가족'})</Typography>
                    </Typography>

                    <Chip label={result.service} size="small" variant="outlined" sx={{ verticalAlign: 'top', color: '#5ead3d', width: 70, border: '1px solid #5ead3d' }}></Chip>
                    {/* <Chip label='확정' size="small" sx={{ verticalAlign: 'top', bgcolor:'#f18322', color:'#fff'  }}></Chip> */}
                  </Stack>
                  <Divider sx={{ mb: 4 }}>
                    <Chip icon={<LocalHospitalIcon />} label="결과" sx={{ width: 90, pl: '5px' }} />
                  </Divider>
                  {/* <Stack direction="column" spacing={0} sx={{ p: 2, pt: 0 }}>
                            <Typography sx={{ fontSize: 14, mb: 0.5 }}>
                              30만원 종합형
                            </Typography>
                            <Typography sx={{ fontSize: 12, }}>
                              위내시경, 뇌CT(128채널 이상), 갑상선 초음파
                            </Typography>
                          </Stack> */}

                  {/*
                          <Stack direction="row" justifyContent={'center'} alignItems={'center'} sx={{ bgcolor: '#f5f5f5', p: 1 }}>
                            <SentimentSatisfiedAltIcon sx={{ fontSize: 30, bgcolor: '#fff', borderRadius: '50%', color: '#48bf00' }} />
                            <Typography sx={{ fontSize: 16, fontWeight: 700, ml: 1, color: '#48bf00' }}>정상A</Typography>
                          </Stack>
                  
                          <Stack direction="row" justifyContent={'center'} alignItems={'center'}  sx={{ bgcolor: '#f5f5f5', p:1 }}>
                            <SentimentNeutralIcon sx={{fontSize:30, bgcolor:'#fff', borderRadius:'50%', color:'#f5ac00'}} />
                            <Typography sx={{ fontSize: 16, fontWeight: 700, ml:1, color:'#f5ac00'}}>정상B(경계)</Typography>
                          </Stack>
                  
                          <Stack direction="row" justifyContent={'center'} alignItems={'center'}  sx={{ bgcolor: '#f5f5f5', p:1 }}>
                            <SickIcon sx={{fontSize:30, bgcolor:'#fff', borderRadius:'50%', color:'#f37200'}} />
                            <Typography sx={{ fontSize: 16, fontWeight: 700, ml:1, color:'#f37200'}}>일반질환의심</Typography>
                          </Stack>
                  */}

                  <Stack direction={'column'} sx={{ p: 2 }}>
                    <Stack direction={'row'} justifyContent={'space-evenly'} spacing={2} mb={2}>
                      <HealthResultItem
                        componentName="기본검사"
                        anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '기본검사')}
                        src={icon_inspection1} width="100%" />

                      <HealthResultItem
                        componentName="신장검사"
                        anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '신장검사')}
                        src={icon_inspection2} width="100%" />

                      <HealthResultItem
                        componentName="일반혈액"
                        anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '일반혈액검사')}
                        src={icon_inspection3} width="100%" />

                      <HealthResultItem
                        componentName="심혈관계"
                        anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '심혈관계검사')}
                        src={icon_inspection4} width="100%" />
                    </Stack>

                    <Stack direction={'row'} justifyContent={'space-evenly'} spacing={2} mb={2}>
                      <HealthResultItem
                        componentName="간기능 / 간염"
                        anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '간기능/간염검사')}
                        src={icon_inspection5} width="100%" />

                      <HealthResultItem
                        componentName="당뇨 / 췌장 / 빈혈"
                        anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '당뇨/췌장/빈혈검사')}
                        src={icon_inspection6} width="100%" />

                      <HealthResultItem
                        componentName="갑상선 / 류마티스 / 통풍"
                        anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '갑상선/류마티스/통풍검사')}
                        src={icon_inspection7} width="100%" />

                      <HealthResultItem
                        componentName="종양검사"
                        anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '종양검사')}
                        src={icon_inspection8} width="100%" />
                    </Stack>

                    <Stack direction={'row'} justifyContent={'space-evenly'} spacing={2} mb={2}>
                      <HealthResultItem
                        componentName="비뇨 / 생식계"
                        anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '비뇨생식계 및 성별 질환')}
                        src={icon_inspection9} width="100%" />

                      <HealthResultItem
                        componentName="장비검사"
                        anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '장비검사')}
                        src={icon_inspection10} width="100%" />

                      <HealthResultItem
                        componentName="기타검사"
                        anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '기타검사')}
                        src={icon_inspection11} width="100%" />

                      <HealthResultItem
                        componentName="종합소견"
                        anchor="bottom" resultItemData={util.strNull(result.totalResult) !== '' ? result.totalResult.split('\r\n\r\n') : []}
                        src={icon_inspection12} width="100%" />
                    </Stack>
                  </Stack>

                  <HealthResultTotal
                    componentName="전체 검진결과 보기"
                    anchor="bottom" resultItemData={result.resultItemList}
                    totalResult={util.strNull(result.totalResult) !== '' ? result.totalResult.split('\r\n\r\n') : []}
                    src="" width="" />

                </Card>
              ))
            )}


      <Bottom />
    </Container >
  );
}

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  m: '3 0',
  mt: 8,
  boxSizing: 'border-box',
  width: '80%',
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#0d6703',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #0d6703',
  ':hover': {
    backgroundColor: '#074300',
    borderColor: '#074300',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#074300',
    borderColor: '#074300',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default HealthResult;